import React from "react";

const ContactClick = () => {
  return (
    <div>
      <iframe
        src="https://kwid.renault.co.in/kwid/?_gl=1*..."
        title="Renault KWID"
        className="embed-frame"
        style={{ width: "100%", height: "90vh", border: "none" }}
      />
    </div>
  );
};

export default ContactClick;
